import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                   */
const FlyoutTrigger = ({
  children,
  className,
  isMenuOpen,
  title,
  tealiumAttributes,
  ...rest
}) => {
  const classNames = classnames("flyout-trigger", className, {
    "flyout-trigger--menu-open": isMenuOpen
  });
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      "aria-label": title,
      "aria-expanded": isMenuOpen,
      "aria-haspopup": true,
      className: classNames,
      ...tealiumAttributes
    },
    children,
    /* @__PURE__ */ React.createElement(Icon, { name: "chevron-down", className: "flyout-trigger__icon" })
  );
};
export {
  FlyoutTrigger as default
};
//# sourceMappingURL=FlyoutTrigger.js.map
